module.exports = __webpack_public_path__ + "static/media/Office98_in.522e52b0.jpg";